var UniversalHeadController = /** @class */ (function () {
    function UniversalHeadController(cacheController, includer) {
        this.cacheController = cacheController;
        this.includer = includer || false;
    }
    UniversalHeadController.prototype.includeCss = function (url) {
        var isNew = this.cacheController.setCssUrl(url);
        if (isNew && this.includer) {
            return this.includer.includeCss(url);
        }
        return Promise.resolve();
    };
    UniversalHeadController.prototype.getCssTags = function () {
        return this.cacheController
            .getCssUrls()
            .reduce(function (acc, url) { return "".concat(acc).concat(getLinkTag(url)); }, "");
    };
    UniversalHeadController.prototype.getTags = function () {
        return "".concat(this.getCssTags());
    };
    UniversalHeadController.prototype.getCache = function () {
        return this.cacheController.getCache();
    };
    return UniversalHeadController;
}());
export { UniversalHeadController };
// function getScriptTag(url: string): string {
//   return `<script src="${url}"></script>`;
// }
function getLinkTag(url) {
    return "<link rel=\"stylesheet\" type=\"text/css\" href=\"".concat(url, "\"></link>");
}
// getJsTags(): string {
//   return this.cache.jsUrls.reduce(
//     (acc, url) => `${acc}${getScriptTag(url)}`,
//     ""
//   );
// }
